mutation HardDeleteAccount($accountId: ID!) {
    accountHardDelete(accountId: $accountId) {
        success
    }
}
